import useInLightMode from '../../../hooks/useInLightMode';
import { useUserDateTime } from '../../timezone/hooks/useUserDateTime';

export const useGetMarkerHistoryChartOptions = (
  yAxisLabel: string,
  title: string,
  yAxisMin?: number,
  yAxisMax?: number,
  xAxisUnit?: string
) => {
  const {
    monthAbbreviatedWordDayFormat,
    timeFormatNoSeconds,
    timeFormatHoursOnly,
    dateFormat,
    timeFormat,
  } = useUserDateTime();
  const inLightMode = useInLightMode();
  return {
    spanGaps: false,
    animation: {
      duration: 0,
    },
    responsive: true,
    plugins: {
      legend: {
        display: true,
        labels: {
          color: inLightMode ? undefined : '#ffffff',
        },
      },
      title: {
        display: true,
        text: title,
        color: inLightMode ? undefined : '#ffffff',
      },
      tooltip: {
        interaction: {
          intersect: false,
        },
      },
    },
    select: {
      line: false,
    },
    elements: {
      point: {
        radius: 0,
      },
    },
    scales: {
      y: {
        min: yAxisMin,
        max: yAxisMax,
        ticks: {
          color: inLightMode ? undefined : '#ffffff',
        },
        grid: {
          color: inLightMode ? undefined : 'rgba(255,255,255,0.5)',
          tickLength: 5,
        },
        title: {
          display: true,
          color: inLightMode ? undefined : 'white',
          text: yAxisLabel,
        },
      },
      x: {
        type: 'time',
        time: {
          tooltipFormat: `${dateFormat} ${timeFormat}`,
          unit: xAxisUnit,
          displayFormats: {
            day: monthAbbreviatedWordDayFormat,
            hour: timeFormatHoursOnly,
            minute: timeFormatNoSeconds,
            second: timeFormat,
          },
        },
        ticks: {
          color: inLightMode ? undefined : '#ffffff',
          //@ts-ignore
          callback: function (value, index, values) {
            if (index === 0) return value;
            if (
              index === (values.length - 1) / 2 ||
              index === (values.length - 2) / 2
            )
              return value;
            if (index === values.length - 1 || index === values.length - 2)
              return value;
            return ' ';
          },
        },
        grid: {
          color: inLightMode ? undefined : 'rgba(255,255,255,0.5)',
          tickLength: 5,
        },
        title: {
          display: true,
          color: inLightMode ? undefined : 'white',
          text: 'Time',
        },
      },
    },
  };
};
